import { useState, useEffect } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import SoftPhone from "./SoftPhone";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import {
  LayoutDashboard,
  Users,
  FileText,
  Building2,
  ShieldCheck,
  Landmark,
  Mail,
  ShoppingCart,
  DollarSign,
  Kanban,
  BarChart3,
  Settings,
  Menu,
  X,
  ChevronRight,
  ChevronDown,
  Calculator,
  ClipboardList,
  Shield,
  UserCog,
  LogOut,
  Building,
  Target,
  CircleDollarSign,
  CheckCircle2,
  UsersRound,
  Database,
  MessageCircle,
  Phone,
  Megaphone,
  Briefcase,
  KeyRound,
} from "lucide-react";
import { cn } from "@/lib/utils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

const menuItems = [
  {
    title: "Dashboard",
    icon: LayoutDashboard,
    href: "/",
    moduloId: "dashboard",
    ocultarPara: ["ATENDENTE", "CORRETOR", "TELEMARKETING", "GESTOR_ADMINISTRATIVO", "GESTOR_OPERACIONAL"],
  },
  {
    title: "Clientes",
    icon: Users,
    href: "/clientes",
    moduloId: "clientes",
    permissao: "acessar_clientes",
  },
  {
    title: "Monitoramento Contrato",
    icon: Landmark,
    href: "/contratos",
    moduloId: "monitoramento_contrato",
    permissao: "acessar_contratos",
    ocultarPara: ["ATENDENTE", "TELEMARKETING"],
  },
  {
    title: "Cadastro Contrato",
    icon: FileText,
    href: "/cadastro-contrato",
    moduloId: "cadastro_contrato",
    permissao: "cadastrar_contrato",
    ocultarPara: ["ATENDENTE", "TELEMARKETING"],
  },
  {
    title: "Simulador",
    icon: Calculator,
    href: "/simulador",
    moduloId: "simulador",
  },
  {
    title: "Bancos",
    icon: Building2,
    href: "/bancos",
    moduloId: "bancos",
    permissao: "acessar_bancos",
  },
  {
    title: "Motor de Crédito",
    icon: ShieldCheck,
    href: "/motor-credito",
    moduloId: "bancos",
    permissao: "acessar_bancos",
  },
  {
    title: "Tabelas de Comissão",
    icon: Calculator,
    href: "/tabelas-comissao",
    moduloId: "tabelas_comissao",
    permissao: "acessar_comissoes",
  },
  {
    title: "Órgãos",
    icon: Building2,
    href: "/orgaos",
    moduloId: "orgaos",
    ocultarPara: ["ATENDENTE", "CORRETOR", "TELEMARKETING", "GESTOR_ADMINISTRATIVO", "GESTOR_OPERACIONAL"],
  },
  {
    title: "Vendas",
    icon: ShoppingCart,
    href: "/vendas",
    moduloId: "vendas",
    permissao: "acessar_vendas",
  },
  {
    title: "Gestão de Contas",
    icon: DollarSign,
    href: "/financeiro",
    moduloId: "financeiro",
    permissao: "acessar_financeiro",
  },
  {
    title: "Atendimento WhatsApp",
    icon: MessageCircle,
    href: "/atendimento-whatsapp",
    moduloId: "atendimento_whatsapp",
  },
  {
    title: "Central VoIP",
    icon: Phone,
    href: "/central-voip",
    moduloId: "central_voip",
    ocultarPara: ["ATENDENTE", "CORRETOR", "TELEMARKETING"],
  },
  {
    title: "Gestão de Telefones",
    icon: Users,
    href: "/gestao-telefones",
    moduloId: "sms_marketing",
  },
  {
    title: "SMS Marketing",
    icon: Megaphone,
    href: "/sms-marketing",
    moduloId: "sms_marketing",
    ocultarPara: ["ATENDENTE", "CORRETOR", "TELEMARKETING"],
  },
  {
    title: "Prospecta CLT",
    icon: Briefcase,
    href: "/prospecta-clt",
    moduloId: "dashboard_leads_base",
    ocultarPara: ["ATENDENTE"],
  },
  {
    title: "E-Mail / Landing Page",
    icon: Mail,
    href: "/servidor-federal",
    moduloId: "dashboard_leads_base",
  },
  {
    title: "Plano de Metas",
    icon: Target,
    href: "/metas",
    moduloId: "plano_metas",
  },
  {
    title: "Dashboard de Leads",
    icon: UsersRound,
    href: "/dashboard-leads",
    moduloId: "dashboard_leads",
    permissao: "acessar_esteira_cliente",
    ocultarPara: ["ATENDENTE", "CORRETOR", "TELEMARKETING", "GESTOR_ADMINISTRATIVO", "GESTOR_OPERACIONAL"],
  },
  {
    title: "Leads Base",
    icon: Database,
    href: "/dashboard-leads-base",
    moduloId: "dashboard_leads_base",
    permissao: "acessar_esteira_cliente",
    ocultarPara: ["ATENDENTE", "CORRETOR", "TELEMARKETING"],
  },
  {
    title: "Relatórios",
    icon: BarChart3,
    href: "/relatorios",
    moduloId: "relatorios",
    permissao: "acessar_relatorios",
  },
  {
    title: "Identificação Única",
    icon: KeyRound,
    href: "/relatorios/identificacao-unica",
    moduloId: "relatorios",
    permissao: "acessar_relatorios",
  },
  {
    title: "Clientes Aprovados",
    icon: BarChart3,
    href: "/relatorios/aprovados",
    moduloId: "relatorios",
    permissao: "acessar_relatorios",
  },
];

const menuGestao = [
  {
    title: "Usuários",
    icon: UserCog,
    href: "/gestao/usuarios",
    permissao: "listar_usuarios",
    moduloId: "gestao_usuarios",
  },
  {
    title: "Empresas",
    icon: Building,
    href: "/gestao/empresas",
    permissao: "listar_empresas",
    apenasmaster: true,  // Só aparece para MASTER_GERAL
  },
];

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [gestaoOpen, setGestaoOpen] = useState(false);
  // Inicializar authChecked como true se já tem token (evita flash de loading)
  const [authChecked, setAuthChecked] = useState(() => !!localStorage.getItem("token"));
  const location = useLocation();
  const navigate = useNavigate();
  
  // Estado do usuário logado - inicializar do localStorage imediatamente
  const [usuario, setUsuario] = useState(() => {
    try { const d = localStorage.getItem("usuario"); return d ? JSON.parse(d) : null; } catch { return null; }
  });
  const [empresa, setEmpresa] = useState(() => {
    try { const d = localStorage.getItem("empresa"); return d && d !== "null" ? JSON.parse(d) : null; } catch { return null; }
  });
  const [permissoes, setPermissoes] = useState(() => {
    try { const d = localStorage.getItem("permissoes"); return d ? JSON.parse(d) : []; } catch { return []; }
  });
  const [modulosPermitidos, setModulosPermitidos] = useState(() => {
    try { const d = localStorage.getItem("empresa"); const e = d && d !== "null" ? JSON.parse(d) : null; return e?.modulos_permitidos || []; } catch { return []; }
  });

  // Verificação de autenticação - OBRIGATÓRIA (background, sem bloquear UI)
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    
    // Verificar token no backend (em background)
    axios.get(`${API}/api/auth/verificar?token=${token}`)
      .then(response => {
        if (!response.data.valid) {
          localStorage.removeItem("token");
          localStorage.removeItem("usuario");
          localStorage.removeItem("empresa");
          localStorage.removeItem("permissoes");
          navigate("/login", { replace: true });
        } else {
          setAuthChecked(true);
        }
      })
      .catch(() => {
        setAuthChecked(true);
      });
  }, [navigate]);

  useEffect(() => {
    // Verificar se está na área de gestão
    if (location.pathname.startsWith("/gestao")) {
      setGestaoOpen(true);
    }
  }, [location.pathname]);

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        await axios.post(`${API}/api/auth/logout?token=${token}`);
      }
    } catch (error) {
      console.error("Erro no logout:", error);
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("usuario");
      localStorage.removeItem("empresa");
      localStorage.removeItem("permissoes");
      toast.success("Logout realizado com sucesso");
      navigate("/login");
    }
  };
  
  // Verificar se um módulo está liberado para a empresa
  const moduloLiberado = (moduloId) => {
    // Master sempre tem acesso a tudo
    if (usuario?.perfil === "MASTER_GERAL") return true;
    // Se não há empresa selecionada ou não há restrição de módulos, libera tudo
    if (!empresa || !modulosPermitidos || modulosPermitidos.length === 0) return true;
    // Verificar se o módulo está na lista de permitidos
    return modulosPermitidos.includes(moduloId);
  };

  const temPermissao = (permissao) => {
    if (!permissao) return true;
    if (usuario?.perfil === "MASTER_GERAL") return true;
    return permissoes.includes(permissao);
  };

  const getIniciais = (nome) => {
    if (!nome) return "U";
    const partes = nome.split(" ");
    if (partes.length >= 2) {
      return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
    }
    return nome.substring(0, 2).toUpperCase();
  };

  const getPerfilLabel = (perfil) => {
    const labels = {
      MASTER_GERAL: "Master Geral",
      ADMIN_EMPRESA: "Admin",
      CORRETOR: "Corretor",
      ATENDENTE: "Atendente",
      TELEMARKETING: "Telemarketing",
      GESTOR_ADMINISTRATIVO: "G. Admin",
      GESTOR_OPERACIONAL: "G. Operac."
    };
    return labels[perfil] || perfil;
  };

  const getPerfilColor = (perfil) => {
    const colors = {
      MASTER_GERAL: "bg-purple-500",
      ADMIN_EMPRESA: "bg-blue-500",
      CORRETOR: "bg-green-500",
      ATENDENTE: "bg-orange-500",
      TELEMARKETING: "bg-cyan-500",
      GESTOR_ADMINISTRATIVO: "bg-indigo-500",
      GESTOR_OPERACIONAL: "bg-rose-500"
    };
    return colors[perfil] || "bg-orange-500";
  };

  // Verificar se deve mostrar menu de gestão
  const mostrarMenuGestao = usuario?.perfil === "MASTER_GERAL" || 
    usuario?.perfil === "ADMIN_EMPRESA" ||
    menuGestao.some(item => temPermissao(item.permissao));

  // Bloquear renderização até verificar autenticação
  if (!authChecked) {
    const token = localStorage.getItem("token");
    if (!token) return null; // Será redirecionado pelo useEffect
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-sm text-gray-500">Verificando sessão...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <aside
        className={cn(
          "fixed inset-y-0 left-0 z-50 flex flex-col bg-slate-900 text-white transition-all duration-300",
          sidebarOpen ? "w-64" : "w-16"
        )}
      >
        {/* Logo */}
        <div className="flex h-16 items-center justify-between px-4">
          {sidebarOpen && (
            <div className="flex items-center gap-2">
              {empresa?.logo_url ? (
                <img 
                  src={`${API}${empresa.logo_url}`} 
                  alt={empresa?.nome || "Logo"} 
                  className="h-10 max-w-[140px] object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <div 
                className={cn(
                  "flex items-center gap-2",
                  empresa?.logo_url && "hidden"
                )}
              >
                <div className="h-8 w-8 rounded-lg stilocred-gradient flex items-center justify-center">
                  <span className="text-white font-bold text-lg">S</span>
                </div>
                <span className="font-bold text-xl">StiloCred</span>
              </div>
            </div>
          )}
          <Button
            variant="ghost"
            size="icon"
            className="text-white hover:bg-slate-800"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            data-testid="toggle-sidebar-btn"
          >
            {sidebarOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </Button>
        </div>

        <Separator className="bg-slate-700" />

        {/* Navigation */}
        <ScrollArea className="flex-1 py-4">
          <nav className="space-y-1 px-2">
            {menuItems.map((item) => {
              // Verificar se o item deve ser oculto para o perfil do usuário
              if (item.ocultarPara && item.ocultarPara.includes(usuario?.perfil)) {
                return null;
              }
              
              // Verificar se o módulo está liberado
              if (item.moduloId && !moduloLiberado(item.moduloId)) {
                return null;
              }
              
              // Verificar se o usuário tem permissão para acessar
              if (item.permissao && !temPermissao(item.permissao)) {
                return null;
              }
              
              const isActive = location.pathname === item.href || 
                (item.href !== "/" && location.pathname.startsWith(item.href));
              
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={cn(
                    "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-all",
                    isActive
                      ? "bg-primary text-white"
                      : "text-slate-300 hover:bg-slate-800 hover:text-white"
                  )}
                  data-testid={`nav-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <item.icon className="h-5 w-5 flex-shrink-0" />
                  {sidebarOpen && (
                    <>
                      <span className="flex-1">{item.title}</span>
                      {isActive && <ChevronRight className="h-4 w-4" />}
                    </>
                  )}
                </Link>
              );
            })}

            {/* Menu de Gestão de Acesso */}
            {mostrarMenuGestao && sidebarOpen && (
              <>
                <Separator className="my-2 bg-slate-700" />
                <Collapsible open={gestaoOpen} onOpenChange={setGestaoOpen}>
                  <CollapsibleTrigger asChild>
                    <button
                      className={cn(
                        "flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-all",
                        location.pathname.startsWith("/gestao")
                          ? "bg-primary/20 text-white"
                          : "text-slate-300 hover:bg-slate-800 hover:text-white"
                      )}
                    >
                      <Shield className="h-5 w-5 flex-shrink-0" />
                      <span className="flex-1 text-left">Gestão de Acesso</span>
                      <ChevronDown className={cn(
                        "h-4 w-4 transition-transform",
                        gestaoOpen && "rotate-180"
                      )} />
                    </button>
                  </CollapsibleTrigger>
                  <CollapsibleContent className="space-y-1 pl-4 mt-1">
                    {menuGestao.map((item) => {
                      // Se é "apenasmaster" e usuário não é MASTER_GERAL, não mostra
                      if (item.apenasmaster && usuario?.perfil !== "MASTER_GERAL") return null;
                      if (!temPermissao(item.permissao)) return null;
                      // Verificar se o módulo está liberado
                      if (item.moduloId && !moduloLiberado(item.moduloId)) return null;
                      
                      const isActive = location.pathname === item.href;
                      
                      return (
                        <Link
                          key={item.href}
                          to={item.href}
                          className={cn(
                            "flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-all",
                            isActive
                              ? "bg-primary text-white"
                              : "text-slate-400 hover:bg-slate-800 hover:text-white"
                          )}
                        >
                          <item.icon className="h-4 w-4 flex-shrink-0" />
                          <span>{item.title}</span>
                        </Link>
                      );
                    })}
                  </CollapsibleContent>
                </Collapsible>
              </>
            )}

            {mostrarMenuGestao && !sidebarOpen && (
              <Link
                to="/gestao/usuarios"
                className={cn(
                  "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-all",
                  location.pathname.startsWith("/gestao")
                    ? "bg-primary text-white"
                    : "text-slate-300 hover:bg-slate-800 hover:text-white"
                )}
                title="Gestão de Acesso"
              >
                <Shield className="h-5 w-5 flex-shrink-0" />
              </Link>
            )}
          </nav>
        </ScrollArea>

        {/* User Info & Settings */}
        <Separator className="bg-slate-700" />
        <div className="p-2">
          {usuario ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-slate-300 hover:bg-slate-800 hover:text-white transition-all">
                  <Avatar className="h-8 w-8">
                    <AvatarFallback className={getPerfilColor(usuario.perfil)}>
                      {getIniciais(usuario.nome)}
                    </AvatarFallback>
                  </Avatar>
                  {sidebarOpen && (
                    <div className="flex-1 text-left">
                      <p className="text-sm font-medium truncate">{usuario.nome?.split(" ")[0]}</p>
                      <p className="text-xs text-slate-400">{getPerfilLabel(usuario.perfil)}</p>
                    </div>
                  )}
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuLabel>
                  <div className="flex flex-col">
                    <span>{usuario.nome}</span>
                    <span className="text-xs font-normal text-gray-500">{usuario.email}</span>
                  </div>
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                {empresa && (
                  <>
                    <DropdownMenuItem disabled>
                      <Building className="mr-2 h-4 w-4" />
                      {empresa.nome_fantasia || empresa.razao_social}
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                  </>
                )}
                <DropdownMenuItem>
                  <Badge className={cn("mr-2", getPerfilColor(usuario.perfil))}>
                    {getPerfilLabel(usuario.perfil)}
                  </Badge>
                  {usuario.codigo_usuario && (
                    <span className="text-xs text-gray-500">({usuario.codigo_usuario})</span>
                  )}
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={handleLogout} className="text-red-600">
                  <LogOut className="mr-2 h-4 w-4" />
                  Sair
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <Link
              to="/login"
              className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-slate-300 hover:bg-slate-800 hover:text-white transition-all"
            >
              <LogOut className="h-5 w-5 flex-shrink-0" />
              {sidebarOpen && <span>Entrar</span>}
            </Link>
          )}
        </div>
      </aside>

      {/* Main Content */}
      <div
        className={cn(
          "flex flex-1 flex-col min-w-0 transition-all duration-300",
          sidebarOpen ? "ml-64" : "ml-16"
        )}
      >
        {/* Top Bar com info da empresa */}
        {empresa && (
          <div className="h-10 bg-white border-b flex items-center justify-between px-4">
            <div className="flex items-center gap-2 text-sm">
              <Building className="h-4 w-4 text-gray-400" />
              <span className="font-medium">{empresa.nome_fantasia || empresa.razao_social}</span>
              <Badge variant="outline" className="text-xs">{empresa.plano}</Badge>
            </div>
            {usuario && (
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <span>Olá, {usuario.nome?.split(" ")[0]}</span>
                {usuario.funcao_codigo && (
                  <Badge variant="secondary" className="text-xs">{usuario.funcao_codigo}</Badge>
                )}
              </div>
            )}
          </div>
        )}
        
        {/* Page Content */}
        <main className="flex-1 overflow-auto bg-slate-50 p-6">
          <Outlet />
        </main>
        <SoftPhone />
      </div>
    </div>
  );
}
